import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Button from '../components/Button';
import Input from '../components/Input';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export default function CandidatePortal() {
  const { token } = useParams<{ token: string }>();
  const [candidate, setCandidate] = useState<any>(null);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ nric: '', address: '', bankAccount: '', emergencyContact: '' });

  useEffect(() => {
    axios
      .get(`${API_URL}/candidate-portal/${token}`)
      .then((res) => {
        setCandidate(res.data.candidate);
        if (res.data.candidate.portal_submission) setForm({ ...form, ...res.data.candidate.portal_submission });
      })
      .catch((err) => setError(err.response?.data?.message || 'Unable to load this link'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/candidate-portal/${token}/submit`, { submission: form });
      setSubmitted(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to submit');
    }
  };

  if (error) return <div className="max-w-lg mx-auto mt-20 p-6 text-center text-red-600">{error}</div>;
  if (!candidate) return <div className="max-w-lg mx-auto mt-20 p-6 text-center">Loading...</div>;

  return (
    <div className="max-w-lg mx-auto mt-16 p-6 bg-white rounded-lg shadow">
      <h1 className="text-xl font-bold mb-1">Complete Your Application</h1>
      <p className="text-gray-600 mb-6">Welcome, {candidate.full_name}. Please provide your personal particulars.</p>

      {submitted ? (
        <p className="text-green-700">Thank you — your submission has been received. HR will review your application.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Input label="NRIC / FIN" value={form.nric} onChange={(e) => setForm({ ...form, nric: e.target.value })} />
          <Input label="Address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
          <Input label="Bank Account No." value={form.bankAccount} onChange={(e) => setForm({ ...form, bankAccount: e.target.value })} />
          <Input label="Emergency Contact" value={form.emergencyContact} onChange={(e) => setForm({ ...form, emergencyContact: e.target.value })} />
          <Button type="submit" className="w-full">
            Submit
          </Button>
        </form>
      )}
    </div>
  );
}
